// Function to determine if an id is a temporary id
// temporary ids are used for offline functionality
export const isTemporaryId = (id: string) => id.includes('temp')

/**
 * Returns a list of unique values
 */
export const getUniqueList = (values?: any[]) =>
  values?.filter((entry, index) => values?.indexOf(entry) === index) || []
